import React, { Component } from 'react';
import { Button, Card, CardBody, CardHeader, Row, Col, CustomInput, Input } from 'reactstrap';
import { getAPI, postAPI } from "../../../Base/API"
import { ErrorAlert } from "../../../Common/ErrorAlert";
import BlockUi from 'react-block-ui';
import { handleNotification } from "../../../Base/Notification"
import { FormattedMessage, injectIntl } from 'react-intl';
import { CommonHelper } from '../../../Base/Common/CommonUIComponents';

// Fixed product-defined list of guest-selectable bed types (BedType enum)
const BED_TYPES = ['Double', 'Twin', 'King', 'Queen', 'Single', 'SofaBed', 'BunkBed', 'ExtraBed'];

class RoomCategoryBedTypes extends Component {

    constructor(props) {
        super(props);
        this.state = {
            error: [],
            block: true,
            selectedBedTypes: []
        };
    }

    componentDidMount() {
        this.getConfiguredBedTypes(this.props.roomCategoryId);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.roomCategoryId !== this.props.roomCategoryId) {
            this.getConfiguredBedTypes(nextProps.roomCategoryId);
        }
    }

    getConfiguredBedTypes = (roomCategoryId) => {
        this.setState({ block: true });

        getAPI(result => {
            const { data, error } = result;
            if (error) {
                this.setState({ error: [{ message: error.message, stack: error.stack, messageType: 'danger' }], block: false });
                return;
            }
            const selectedBedTypes = (data || []).map(item => ({ bedType: item.bedType, isDefault: item.isDefault === true }));
            this.setState({ block: false, selectedBedTypes });
        }, `/api/hotel/RoomCategory/v1/${roomCategoryId}/BedTypes`);
    }

    toggleBedType = (bedType, checked) => {
        let selectedBedTypes = [...this.state.selectedBedTypes];

        if (checked && !selectedBedTypes.some(bt => bt.bedType === bedType)) {
            selectedBedTypes.push({ bedType: bedType, isDefault: false });
        }
        else if (!checked) {
            selectedBedTypes = selectedBedTypes.filter(bt => bt.bedType !== bedType);
        }

        if (selectedBedTypes.length > 0 && !selectedBedTypes.some(bt => bt.isDefault)) {
            selectedBedTypes[0].isDefault = true;
        }

        this.setState({ selectedBedTypes });
    }

    setDefaultBedType = (bedType) => {
        const selectedBedTypes = this.state.selectedBedTypes.map(bt => ({ ...bt, isDefault: bt.bedType === bedType }));
        this.setState({ selectedBedTypes });
    }

    handleSubmit = (e) => {
        e.preventDefault();

        this.setState({ block: true });

        postAPI(result => {
            const { data, error } = result;
            if (error) {
                this.setState({ error: [{ message: error.message, stack: error.stack, messageType: 'danger' }], block: false });
                return;
            }
            if (data) {
                handleNotification(data, <FormattedMessage id="RoomCategoryBedTypes.SuccessMessageSave" />, <FormattedMessage id="General.Success" />);
                this.setState({ block: false, error: [] });
            }
        }, `/api/hotel/RoomCategory/v1/${this.props.roomCategoryId}/BedTypes`, this.state.selectedBedTypes);
    }

    render() {
        const { selectedBedTypes } = this.state;
        const { intl } = this.props;
        const showDefaultChoice = selectedBedTypes.length > 1;

        const bedTypes = BED_TYPES
            .map(bt => ({ value: bt, label: intl.formatMessage({ id: `BedTypes.${bt}` }) }));

        return (
            <div className="mt-3">
                <BlockUi tag="div" blocking={this.state.block}>
                    <ErrorAlert error={this.state.error} />
                    <Card className="small border-0 shadow">
                        <CardHeader className="border-bottom bg-white">
                            <Row>
                                <Col>
                                    <span className="fas fa-bed mr-2" />
                                    <FormattedMessage id="RoomCategoryBedTypes.Title" />
                                </Col>
                                <Col className="text-right col-6 col-md-4 col-lg-2">
                                    <Button color="primary btn-host btn-sm" onClick={this.handleSubmit}>
                                        <i className="fas fa-save" />
                                    </Button>
                                    <CommonHelper help={<FormattedMessage id="RoomCategoryBedTypes.Help" />} id={'RoomCategoryBedTypesHelp'} />
                                </Col>
                            </Row>
                        </CardHeader>
                        <CardBody>
                            <Row>
                                {bedTypes.map(bedType => {
                                    const selected = selectedBedTypes.find(bt => bt.bedType === bedType.value);
                                    return (
                                        <Col key={bedType.value} className="col-12 col-lg-4 col-xl-3 pb-2">
                                            <CustomInput id={`bedType${bedType.value}`} type="checkbox" checked={selected !== undefined} onChange={(e) => this.toggleBedType(bedType.value, e.target.checked)}>
                                                {bedType.label}
                                            </CustomInput>
                                        </Col>
                                    );
                                })}
                            </Row>
                            {showDefaultChoice ?
                                <Row className="mt-3 align-items-center">
                                    <Col className="col-auto pr-0">
                                        <FormattedMessage id="RoomCategoryBedTypes.Default" />
                                    </Col>
                                    <Col className="col-12 col-md-4 col-lg-3">
                                        <Input type="select" value={(selectedBedTypes.find(bt => bt.isDefault) || {}).bedType || ''} onChange={(e) => this.setDefaultBedType(e.target.value)}>
                                            {selectedBedTypes.map(sel => {
                                                const bedType = bedTypes.find(bt => bt.value === sel.bedType);
                                                return <option key={sel.bedType} value={sel.bedType}>{bedType ? bedType.label : sel.bedType}</option>;
                                            })}
                                        </Input>
                                    </Col>
                                </Row>
                                : ''}
                        </CardBody>
                    </Card>
                </BlockUi>
            </div>
        );
    }
}

export default injectIntl(RoomCategoryBedTypes)
